module.exports = __webpack_public_path__ + "static/media/back.a85399ad.svg";